module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraBoldItalic.58087ea.woff2";